import React from 'react';
import { FaAngleDown } from 'react-icons/fa';
import { keyframes } from '@emotion/core';
import styled from '@emotion/styled';
import WithScroll from '../utils/scroll/WithScroll';
import asHoc from '../utils/asHoc';

const bounce = keyframes`
	0% ,10%, 23%, 40% {
		transform: translate3d(0,0,0);
	}
	20% {
		transform: translate3d(0, -30px, 0);
	}

	30% {
		transform: translate3d(0, -15px, 0);
	}
    36% {
        transform: translate3d(0, 3px, 0);
    }
`;

const BounceAnimation = styled.div`
  font-size: 6rem;
  animation: ${bounce} 10s ease infinite;
  transform-origin: center bottom;
  animation-delay: 2000ms;
  cursor: pointer;
`;

const ShowAnimation = styled.div`
  opacity: 0;
  animation-name: 'fadeIn';
  animation-duration: 1s;
  animation-delay: 2s;
  animation-fill-mode: forwards;
`;

class Arrow extends React.Component {
  render() {
    const { viewport } = this.props;
    return (
      <ShowAnimation>
        <BounceAnimation {...this.props}>
          <FaAngleDown style={{ opacity: 1 - viewport.y / 250 }} />
        </BounceAnimation>
      </ShowAnimation>
    );
  }
}

export default asHoc(WithScroll)(Arrow);
